import { render, staticRenderFns } from "./BackBarDefaultSection.vue?vue&type=template&id=610fecbb&scoped=true"
import script from "./BackBarDefaultSection.vue?vue&type=script&lang=ts"
export * from "./BackBarDefaultSection.vue?vue&type=script&lang=ts"
import style0 from "./BackBarDefaultSection.vue?vue&type=style&index=0&id=610fecbb&prod&lang=css"
import style1 from "./BackBarDefaultSection.vue?vue&type=style&index=1&id=610fecbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610fecbb",
  null
  
)

export default component.exports